import { catchError } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { Component, OnInit, Optional, Inject, Input } from '@angular/core';
import { LogService } from '@pershing/pershing-core';
import { TradingEntitlements } from '../../../models/common/trading-entitlements';
import { Account } from '../../../models/common/trading-common.model';
import { TradingService } from '../../../services/common/trading-service.service';
import { OrderActionParams } from '../../../models/common/order-status.model';
import { ORDER_ACTIONS, CONTAINER_TYPE } from '../../../utils/trading-constants';

@Component({
  selector: 'page-container',
  templateUrl: './page-container.component.html',
  styleUrls: ['./page-container.component.css']
})
export class PageContainerComponent implements OnInit {
  // This is used to serve as a standalone page in .COM / .NET for some components, such as: cancel-order, order-settings ...
  @Input() routeParams: any;
  @Input() accountNumber: string;

  @Input() content: string;   // Possible values:  cancel-order | order-settings

  platform: string;
  account: Account;
  errorInFetchingAccountDetails: boolean = false;
  errorInFetchingRolesAndEntitlements: boolean =  false;
  isLoading: boolean = true;

  cancelOrderFromDotComParams: OrderActionParams;
  secType: CONTAINER_TYPE = CONTAINER_TYPE.Equity;
  ordQty: any;
  complex: any;

  constructor(
    private tradingService: TradingService,
    @Optional() @Inject('AppSettings') appSettings: any,
    private logService: LogService
  ) {
    if (appSettings) {
        this.platform = appSettings.platform;
    }
  }
  processCancelOrder(routeContext:any ,complexOptionCdVal: string){
    if (routeContext && routeContext.ordDtlKey && routeContext.subRequestTypeCode
      && routeContext.ordProdCodeText && routeContext.action) {
      let theOrderActionParams: OrderActionParams = { //populate OrderActionParams
          ordDtlKey: routeContext.ordDtlKey,
          origSysRefNo: routeContext.origSysRefNo,
          // ordDtlKey: routeContext.ordDtlKey.replace(/\_/g, ' ').trim(),
          subRequestTypeCode: routeContext.subRequestTypeCode,
          complexOptionStrategyCd: routeContext.strategyCd,
          complexOptionCd: complexOptionCdVal,
          ordProdCodeText: (routeContext.ordProdCodeText || '').replace(/\+/g, ' ').trim(),
          action: routeContext.action,
          accountNo: routeContext.accountNo || this.account.acctNum,
          platform: routeContext.platform || this.platform,
          contextType: routeContext.source,
          isUserFromLegacyOTS: (routeContext.isUserFromLegacyOTS === 'true')
      };
      if (theOrderActionParams.action === ORDER_ACTIONS.CANCEL) {   // double check
          this.cancelOrderFromDotComParams = theOrderActionParams;
      }
    }
  }
  processOrderSettings(routeContext: any){
    // set proper @input data for child component
    if (routeContext && routeContext.containerType) {
      this.secType = routeContext.containerType;
    }
  }
  processRouteParams() {
    let routeContext = JSON.parse(decodeURIComponent(this.routeParams));
    console.log('routeContext value after reading the routeParams', routeContext);
    this.ordQty = routeContext.ordQty;
    this.complex = routeContext.complex;

    let complexOptionCdVal;
    
    if ( !!routeContext.complexOptionCd ) {
      complexOptionCdVal = routeContext.complexOptionCd
    } else {
      // alternate logic to handle requests from the .NET app
      complexOptionCdVal = !!routeContext.strategyCd && routeContext.strategyCd !== 'SI' ? 'Y' : 'N';
    }
    //process cancel order or order settings
    switch (this.content.toLowerCase()) {
      case 'cancel-order': {
        this.processCancelOrder(routeContext,complexOptionCdVal);
        break;
      }
      case 'order-settings': {
        this.processOrderSettings(routeContext);
        break;
      }
      default: {
        break;
      }
    }
  }
  ngOnInit() {
    if (this.accountNumber) {
      this.tradingService.getEntitlements(this.platform);

      const account$ = this.tradingService.getAccountDetails(this.platform, this.accountNumber)
                        .pipe(catchError(error => {
                          this.errorInFetchingAccountDetails = true;
                          throw error;
                        }));

      const entitlement$ = this.tradingService.onEntitlementsSubject$
      .pipe(catchError(error => {
        this.errorInFetchingRolesAndEntitlements = true;
        throw error;
      }));

      combineLatest([account$, entitlement$]).subscribe(([accountResp, entitlementResp]) => {
        if (!!accountResp && !!entitlementResp) {
          this.accountDetailsSuccessCallback(accountResp);
          this.entitlementsSuccessCallback(entitlementResp);
          this.isLoading = false;

          if (this.routeParams) {
            this.processRouteParams();
          }
        }
      });
    }
  }

  private accountDetailsSuccessCallback(accountDetailsSuccessResponse: any): void {
    if (accountDetailsSuccessResponse?.errorCode === 0) {
      this.account = accountDetailsSuccessResponse.response as Account;
      this.errorInFetchingAccountDetails = false;
    } else {
        this.errorInFetchingAccountDetails = true;
    }
  }

  private entitlementsSuccessCallback(entitlementsResponse: any): void {
    if ( entitlementsResponse?.errorCode === 0 ) {
      this.tradingService.tradingEntitlements = entitlementsResponse.response as TradingEntitlements;
      this.errorInFetchingRolesAndEntitlements = false;
    } else {
      this.errorInFetchingRolesAndEntitlements = true;
    }
  }

}
